import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {HttpHandler, 
        HttpEvent, 
        HttpInterceptor, 
        HttpRequest, 
        HttpErrorResponse} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry, catchError, finalize } from 'rxjs/operators';

import { AuthService } from "./../services/auth.service"
import { LoaderService } from '../services/loader.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        public auth: AuthService, 
        private router: Router,
        private loaderService: LoaderService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
        this.loaderService.show();
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.auth.getToken()}`,
            'ngrok-skip-browser-warning': 'true' 
          }
        });

        return  next
                .handle(request)
                .pipe(
                    finalize(() => this.loaderService.hide()),
                    retry(1),
                    catchError((error: HttpErrorResponse) => {
                        let errorMessage = '';

                        if (error.error instanceof ErrorEvent) {
                            // client-side error
                            errorMessage = `Error: ${error.error.message}`;
                        } else {
                            // server-side error
                            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
                        }

                        if (error.status === 401 || error.status === 403) {
                            this.router.navigateByUrl(`/login`);

                            return throwError(errorMessage);
                        }                

                        return throwError(errorMessage);
                    }),
                );
    }    
}